export const API_BASE_URL = 'https://aftermath.finance/api/price-info';
export const PATARA_METADATA_API_BASE_URL = 'https://api.patara.app/metadata';

export const PATARA_METADATA_API_ENDPOINTS = {
  SINGLE_COIN_METADATA: 'coin-metadata',
  MULTIPLE_COIN_METADATA: 'multiple-coin-metadata',
  TAGGED_COINS: 'tagged-coins',
  SEARCH: 'search',
  MULTIPLE_COIN_DECIMALS: 'multiple-coin-decimals',
  SINGLE_COIN_DECIMALS: 'coin-decimals',
} as const;
